import Slider from "rc-slider"
import "rc-slider/assets/index.css"
import { useState } from "react"
import { H1, H2, HorizontalGroup, P, VerticalGroup } from "../components"
import Anchor from "../components/anchor/anchor"
import Body from "../components/body/body"
import { InnerContainer } from "../components/body/body_style"
import DirectionSwitch from "../components/directionSwitch"
import FeatureList from "../components/featureList/featureList"
import { HoverContainer } from "../components/featureList/featureList_style"
import { ContactType } from "../pages/contact"
import { SmallContainer } from "../styles"

const Pricing = () => {
	const [slider, setSlider] = useState(100)
	const [premiumParticipants, setPremiumParticipants] = useState(100)
	const [infoHovered, setInfoHovered] = useState(-1)

	const features = {
		free: [
			{
				title: "All Features",
				hoverInfo:
					"You can use all available features in this version without any restrictions. ",
			},
			{
				title: "Fully Customizable",
				hoverInfo: "You can decide for yourself what your space looks like. ",
			},
		],
		premium: [
			{
				title: "All Features",
				hoverInfo:
					"You can use all available features in this version without any restrictions. ",
			},
			{
				title: "Fully Customizable",
				hoverInfo: "You can decide for yourself what your space looks like. ",
			},
			{
				title: "Up to 3 Subspaces",
				hoverInfo:
					"With Subspaces, your participants can jump back and forth between rooms.",
			},
			{
				title: "Bookable Support",
				hoverInfo:
					"Your participants need support using SaySom? No worries. We are here to help. ",
			},
			{
				title: "Bookable Space Designer",
				hoverInfo:
					"Need help creating a design for your SaySom space? We can help!",
			},
		],
		enterprise: [
			{
				title: "All Features",
				hoverInfo:
					"You can use all available features in this version without any restrictions. ",
			},
			{
				title: "Fully Customizable",
				hoverInfo: "You can decide for yourself what your space looks like. ",
			},
			{
				title: "Many Subspaces",
				hoverInfo:
					"With Subspaces, your participants can jump back and forth between rooms.",
			},
			{
				title: "Inclusive Support",
				hoverInfo:
					"Your participants need support using SaySom? No worries. We are here to help. ",
			},
			{
				title: "Inclusive Space Designer",
				hoverInfo:
					"Need help creating a design for your SaySom space? We can help!",
			},
			{
				title: "Event Platform Integration",
				hoverInfo:
					"We take over the integration into a third external event platform.",
			},
		],
	}

	return (
		<Body
			noPadding
			className="bg-flowy-up dark:bg-flowy-up-dark"
			whiteFooter
			subtitle="Pricing"
		>
			<InnerContainer
				width="1200px"
				style={{
					justifyContent: "center",
				}}
			>
				<DirectionSwitch className="min-w-280 md:min-w-min self-center md:self-stretch">
					<div className="flex flex-1 md:pt-20 self-stretch md:min-w-0">
						<SmallContainer
							mt="80px"
							backgroundColor="white"
							justify="space-between"
							className="text-black"
						>
							<VerticalGroup>
								<H1 style={{ marginBottom: "10px" }}>Free</H1>
								<H2 style={{ marginBottom: "12px" }}>20 participants</H2>
								<FeatureList data={features.free} />
							</VerticalGroup>
							<VerticalGroup>
								<H1 style={{ alignSelf: "center" }}>0€</H1>
								<P style={{ alignSelf: "center" }}>60 minutes</P>
								<Anchor
									href="/space/create"
									className="w-full flex justify-center bg-black text-white mt-4 shadow-md rounded-md px-5 py-2 text-sm font-semibold select-none cursor-pointer hover:bg-action transition-colors"
								>
									<p>Book now</p>
								</Anchor>
							</VerticalGroup>
						</SmallContainer>
					</div>

					<div className="flex flex-1 md:pt-20 self-stretch md:min-w-0">
						<SmallContainer
							mt="80px"
							mtmd="0px"
							backgroundColor="white"
							justify="space-between"
							className="text-black"
						>
							<VerticalGroup>
								<H1
									className="bg-flowy-text bg-clip-text text-transparent self-start"
									style={{ marginBottom: "10px" }}
								>
									Basic
								</H1>
								<H2 style={{ marginBottom: "12px" }}>50 participants</H2>
								<FeatureList data={features.free} />
							</VerticalGroup>
							<VerticalGroup>
								<H1 style={{ alignSelf: "center" }}>49€</H1>
								<HorizontalGroup
									justifyContent="space-between"
									style={{ position: "relative" }}
								>
									<div style={{ width: "17px" }} />
									<P>per hour</P>
									<svg
										width="17"
										height="16"
										viewBox="0 -1 15 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
										onMouseEnter={() => setInfoHovered(2)}
										onMouseLeave={() => setInfoHovered(-1)}
									>
										<g opacity="0.4">
											<path
												fillRule="evenodd"
												clipRule="evenodd"
												d="M5.5 6.5C5.5 5.39543 6.39543 4.5 7.5 4.5H8.1C9.14934 4.5 10 5.35066 10 6.4V6.5C10 7.60457 9.10457 8.5 8 8.5V9.5H7V7.5H8C8.55228 7.5 9 7.05228 9 6.5V6.4C9 5.90294 8.59706 5.5 8.1 5.5H7.5C6.94772 5.5 6.5 5.94772 6.5 6.5H5.5ZM8 10.5V11.5H7V10.5H8Z"
												fill="#333333"
											/>
											<path
												d="M7.5 14.5C3.91015 14.5 1 11.5899 1 8H-1C-1 12.6944 2.80558 16.5 7.5 16.5V14.5ZM14 8C14 11.5899 11.0899 14.5 7.5 14.5V16.5C12.1944 16.5 16 12.6944 16 8H14ZM7.5 1.5C11.0899 1.5 14 4.41015 14 8H16C16 3.30558 12.1944 -0.5 7.5 -0.5V1.5ZM7.5 -0.5C2.80558 -0.5 -1 3.30558 -1 8H1C1 4.41015 3.91015 1.5 7.5 1.5V-0.5Z"
												fill="#333333"
											/>
										</g>
									</svg>
									<HoverContainer
										alignBottom
										style={{
											opacity: infoHovered === 2 ? 1 : 0,
										}}
									>
										<P style={{ lineHeight: "2px" }}>
											You simply book the required hours in advance. The booked
											time starts from the moment when the host opens the space
											for all participants. Before the opening you can test the
											space with 5 more participants. You realize during the
											event that you need more time? No problem.
										</P>
									</HoverContainer>
								</HorizontalGroup>

								<Anchor
									href={`/contact?reason=${ContactType.BookBasic}`}
									className="w-full flex justify-center bg-black text-white mt-4 shadow-md rounded-md px-5 py-2 text-sm font-semibold select-none cursor-pointer hover:bg-action transition-colors"
								>
									<p>Book basic space</p>
								</Anchor>
							</VerticalGroup>
						</SmallContainer>
					</div>
					<div className="flex flex-1 md:pt-20 self-stretch md:min-w-0">
						<SmallContainer gradient style={{ padding: "10px" }}>
							<SmallContainer
								style={{ borderRadius: "16px" }}
								backgroundColor="rgba(255,255,255,0.5)"
								justify="space-between"
								border="1px solid rgba(255,255,255,0.7)"
								className="text-black"
							>
								<VerticalGroup>
									<H1 className="text-white" style={{ marginBottom: "10px" }}>
										Premium
									</H1>
									<div className="flex flex-row justify-between text-white text-lg">
										<span>100</span>
										<span>800</span>
									</div>
									<Slider
										style={{ marginTop: "10px", marginBottom: "16px" }}
										railStyle={{
											backgroundColor: "rgba(255,255,255,0.2)",
											height: "2px",
											// width: "100%",
											borderRadius: "100px",
										}}
										trackStyle={{
											backgroundColor: "white",
											height: "2px",
											width: "100%",
											borderRadius: "100px",
										}}
										handleStyle={{
											backgroundColor: "white",
											height: "18px",
											width: "18px",
											borderRadius: "9px",
											boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.16)",
											border: 0,
											marginTop: "-8px",
										}}
										onChange={(value) => {
											if (value >= 100 && value <= 800) {
												setSlider(value as number)

												setPremiumParticipants(
													Math.round((value as number) / 50) * 50
												)
											}
										}}
										// onAfterChange={() => console.log("i was givvennn up")}
										value={slider}
										min={70}
										max={830}
									/>

									<H2
										className="tabular-nums mb-2 text-white"
										style={{ fontSize: "22px" }}
									>
										{premiumParticipants} participants
									</H2>

									<FeatureList textColor="white" data={features.premium} />
								</VerticalGroup>
								<VerticalGroup>
									<H1 className="text-white" style={{ alignSelf: "center" }}>
										{premiumParticipants - 1}€
									</H1>
									<HorizontalGroup
										justifyContent="space-between"
										style={{ position: "relative" }}
									>
										<div style={{ width: "17px" }} />
										<P color="white">per hour</P>
										<svg
											width="17"
											height="16"
											viewBox="0 -1 15 18"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
											onMouseEnter={() => setInfoHovered(1)}
											onMouseLeave={() => setInfoHovered(-1)}
										>
											<g opacity="0.4">
												<path
													fillRule="evenodd"
													clipRule="evenodd"
													d="M5.5 6.5C5.5 5.39543 6.39543 4.5 7.5 4.5H8.1C9.14934 4.5 10 5.35066 10 6.4V6.5C10 7.60457 9.10457 8.5 8 8.5V9.5H7V7.5H8C8.55228 7.5 9 7.05228 9 6.5V6.4C9 5.90294 8.59706 5.5 8.1 5.5H7.5C6.94772 5.5 6.5 5.94772 6.5 6.5H5.5ZM8 10.5V11.5H7V10.5H8Z"
													fill="white"
												/>
												<path
													d="M7.5 14.5C3.91015 14.5 1 11.5899 1 8H-1C-1 12.6944 2.80558 16.5 7.5 16.5V14.5ZM14 8C14 11.5899 11.0899 14.5 7.5 14.5V16.5C12.1944 16.5 16 12.6944 16 8H14ZM7.5 1.5C11.0899 1.5 14 4.41015 14 8H16C16 3.30558 12.1944 -0.5 7.5 -0.5V1.5ZM7.5 -0.5C2.80558 -0.5 -1 3.30558 -1 8H1C1 4.41015 3.91015 1.5 7.5 1.5V-0.5Z"
													fill="white"
												/>
											</g>
										</svg>
										<HoverContainer
											alignBottom
											style={{
												opacity: infoHovered === 1 ? 1 : 0,
											}}
										>
											<P style={{ lineHeight: "20px" }}>
												You simply book the required hours in advance. The
												booked time starts from the moment when the host opens
												the space for all participants. Before the opening you
												can test the space with 5 more participants. You realize
												during the event that you need more time? No problem.
											</P>
										</HoverContainer>
									</HorizontalGroup>

									<Anchor
										href={`/contact?reason=${ContactType.BookPremium}&pricing=${premiumParticipants}`}
										className="w-full flex justify-center -mb-2.5  mt-4 shadow-md rounded-md bg-white  px-5 py-2 text-sm font-semibold select-none cursor-pointer text-transparent hover:text-white hover:bg-flowy-text transition-colors"
									>
										<p className="text-sm bg-flowy-text bg-clip-text self-start">
											Book premium space
										</p>
									</Anchor>
								</VerticalGroup>
							</SmallContainer>
						</SmallContainer>
					</div>
					<div className="flex flex-1 md:pt-20 self-stretch md:min-w-0">
						<SmallContainer
							mt="80px"
							mtmd="0px"
							backgroundColor="white"
							justify="space-between"
							className="text-black"
						>
							<VerticalGroup>
								<H1
									className="bg-flowy-text bg-clip-text text-transparent self-start"
									style={{ marginBottom: "10px" }}
								>
									Enterprise
								</H1>
								<H2 style={{ marginBottom: "12px" }}>
									<span style={{ color: "#661AFF" }}>∞</span> participants
								</H2>
								<FeatureList data={features.enterprise} />
							</VerticalGroup>

							<H1 style={{ alignSelf: "center", marginTop: "48px" }}>Custom</H1>
							<Anchor
								href={`/contact?reason=${ContactType.BookEnterprise}`}
								className="w-full flex justify-center bg-black text-white mt-4 shadow-md rounded-md px-5 py-2 text-sm font-semibold select-none cursor-pointer hover:bg-action transition-colors"
							>
								<p>Contact</p>
							</Anchor>
						</SmallContainer>
					</div>
				</DirectionSwitch>
			</InnerContainer>
		</Body>
	)
}

export default Pricing
